import useSasVerificationNotifications from './hooks/useSasVerificationNotifications';

const SasVerificationNotificationsManager = () => {
  useSasVerificationNotifications();
  return null;
};

export default SasVerificationNotificationsManager;
